<template>
  <ms-dialog
    ref="dialog"
    @close="handleClose"
    custom-class="platform-notify-dialog"
  >
    <template #title>
      <div class="dialog-title h4 text-neutral-500">
        {{ formParams?.notify?.Message }}
      </div>
    </template>
    <div class="platform-notify-popup w-full">
      <editor-viewer v-model="formParams.notify.Content" />
    </div>
  </ms-dialog>
</template>

<script>
import BaseDetailPopup from '@/views/base/base-detail-popup.vue'
import { mapActions } from 'vuex'
import { ContextDataKey, getContextData } from '@/utils/context-data'
import EditorViewer from '@/components/editor/src/editor-viewer'

export default {
  extends: BaseDetailPopup,
  components: {
    EditorViewer
  },
  data () {
    return {
      dialogWidth: '960px'
    }
  },
  methods: {
    ...mapActions('notify', ['insertPlaformNotify', 'updateIsReadNotify']),

    /**
     * @description base override
     * @author lhlong
     */
    handleClose () {
      const notifyParams = {
        Message: this.formParams.notify.Message,
        Content: this.formParams.notify.Content,
        IsRead: true,
        IsPreview: true,
        UserID: getContextData(ContextDataKey.UserID),
        OrgID: getContextData(ContextDataKey.OrganizationID),
        NotificationID: this.formParams.notify.NotificationID,
        Time: this.formParams.time,
        Id: this.formParams.notify.Id
      }

      if (!this.formParams.notify.IsRead) {
        switch (this.formParams.notify.Type) {
          case this.$enumeration.NotifyType.PlatformNotify:
            notifyParams.Type = this.$enumeration.NotifyType.PlatformNotify
            break
          case this.$enumeration.NotifyType.ISMACNotify:
            notifyParams.Type = this.$enumeration.NotifyType.ISMACNotify
            break
        }
        this.updateIsReadNotify(notifyParams)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.ckeditor-custom) {
  width: 100%;
}

$dialog-margin: 24px;
$header-height: 100px;
:deep(.el-dialog) {
  max-height: calc(100vh - #{$dialog-margin * 2}) !important;
  // overflow-y: overlay !important;
  .platform-notify-popup {
    max-height: calc(100vh - #{$dialog-margin * 2} - #{$header-height});
    overflow: overlay !important;
    .test-text {
      width: 100%;
      object-fit: cover;
        img {
          width: 100%;
        }
    }
  }
}
</style>
